const heroCard = () => ({ title: "", description: "" });
const insight = () => ({
  title1: "",
  title2: "",
  description: "",
  link: "",
  type: "",
});
const offering = (label = "") => ({ label, title: "", description: "" });
const processStep = (step) => ({
  step,
  title: "",
  time: "",
  description: "",
  tags: [""],
});
const techGroup = () => ({ title: "", items: [""] });
const fact = () => ({ label: "", value: "" });
const approachCard = (number) => ({ number, title: "", description: "" });
const leader = () => ({ image: "", name: "", role: "" });
const stat = () => ({ number: "", label: "" });
const expertiseCard = () => ({ title: "", description: "" });

export const emptyLogos = {
  logosTitle1: "",
  logosTitle2: "",
  logos: [],
  logosHide: false,
};

const emptyAddress = () => ({
  label: "",
  street: "",
  city: "",
  country: "",
  phoneNumber: "",
});
const emptySocial = () => ({ link: "" });
const emptyLink = () => ({ title: "", link: "" });
const emptyColumn = () => ({
  title: "",
  links: [emptyLink(), emptyLink(), emptyLink(), emptyLink()],
});

export const emptyBasic = {
  headerLogo: "",
  headerCtaText: "",
  headerCtaLink: "",
  productMenu1Title: "Product One",
  productMenu2Title: "Product Two",
  productMenu3Title: "Product Three",
  footerLogo: "",
  footerAddresses: [emptyAddress(), emptyAddress()],
  footerFollowTitle: "Follow Us",
  socialMediaIcon: [emptySocial(), emptySocial()],
  footerColumns: [emptyColumn(), emptyColumn(), emptyColumn()],
  footerCertificationText: "",
  footerCertificationLogos: ["", "", ""],
  footerCopyright: "",
  footerLegalLinks: [emptyLink(), emptyLink()],
};

export const emptyHome = {
  heroTag: "",
  heroTitle1: "",
  heroTitle2: "",
  heroDescription: "",
  heroPrimaryCtaText: "",
  heroPrimaryCtaLink: "",
  heroSecondaryCtaText: "",
  heroSecondaryCtaLink: "",
  heroTrustText: "",
  heroLogoCard: { image: "", text: "" },
  heroCard1: { title: "", description: "" },
  heroCard2: { title: "", description: "" },
  heroSectionHide: false,
  servicesTitle: "",
  servicesSubtitle: "",
  services: [{ title: "", description: "" }],
  servicesFooterText: "",
  servicesCtaText: "",
  servicesCtaLink: "",
  servicesHide: false,
  logosTitle1: "",
  logosTitle2: "",
  logos: [],
  logosHide: false,
  processTitle: "",
  processSubTitle: "",
  processSteps: [{ step: 1, title: "", description: "" }],
  processStep1BtnText: "",
  processStep1BtnLink: "",
  processHide: false,
  insightsTitle: "",
  insightsCtaText: "",
  insightsCtaLink: "",
  insight1: insight(),
  insight2: insight(),
  insight3: insight(),
  insightsHide: false,
};

export const emptyServices = {
  heroTag: "",
  heroTitle1: "",
  heroTitle2: "",
  heroDescription: "",
  heroPrimaryCtaText: "",
  heroPrimaryCtaLink: "",
  heroSecondaryCtaText: "",
  heroSecondaryCtaLink: "",
  heroTrustText: "",
  heroLogoCard: { image: "", text: "" },
  heroCard1: heroCard(),
  heroCard2: heroCard(),
  heroSectionHide: false,
  offeringsTag: "",
  offeringsTitle1: "",
  offeringsTitle2: "",
  offeringsSubtitle: "",
  offering1: offering("01"),
  offering2: offering("02"),
  offering3: offering("03"),
  offering4: offering("04"),
  offering5: offering("05"),
  offering6: offering("06"),
  offeringsHide: false,
  logosTitle1: "",
  logosTitle2: "",
  logos: [],
  logosHide: false,
  processTag: "",
  processTitle1: "",
  processTitle2: "",
  processSubtitle: "",
  processStep1: processStep("01"),
  processStep2: processStep("02"),
  processStep3: processStep("03"),
  processStep4: processStep("04"),
  processStep5: processStep("05"),
  processStep6: processStep("06"),
  processHide: false,
  techTag: "",
  techTitle1: "",
  techTitle2: "",
  techSubtitle: "",
  techGroup1: techGroup(),
  techGroup2: techGroup(),
  techGroup3: techGroup(),
  techGroup4: techGroup(),
  techGroup5: techGroup(),
  techGroup6: techGroup(),
  techGroup7: techGroup(),
  techGroup8: techGroup(),
  techGroup9: techGroup(),
  techHide: false,
};

export const emptyCompany = {
  heroBackground: "",
  heroTag: "",
  heroTitle1: "",
  heroTitle2: "",
  heroPrimaryCtaText: "",
  heroPrimaryCtaLink: "",
  heroSecondaryCtaText: "",
  heroSecondaryCtaLink: "",
  heroFact1: fact(),
  heroFact2: fact(),
  heroFact3: fact(),
  heroFact4: fact(),
  heroSectionHide: false,
  approachTag: "",
  approachTitle: "",
  approachCard1: approachCard("01"),
  approachCard2: approachCard("02"),
  approachCard3: approachCard("03"),
  approachHide: false,
  leadershipTitle1: "",
  leadershipTitle2: "",
  leadershipDescription: "",
  leader1: leader(),
  leader2: leader(),
  leader3: leader(),
  leader4: leader(),
  leadershipHide: false,
  stat1: stat(),
  stat2: stat(),
  stat3: stat(),
  stat4: stat(),
  statsHide: false,
  expertiseTitle1: "",
  expertiseTitle2: "",
  expertiseDescription: "",
  expertiseImage: "",
  expertiseCard1: expertiseCard(),
  expertiseCard2: expertiseCard(),
  expertiseCard3: expertiseCard(),
  expertiseHide: false,
};

export const emptyPricing = {
  heroTag: "Build solutions, solve problems",
  heroTitle1: "Fixed Pricing,",
  heroTitle2: "Zero Surprises",
  heroDescription:
    "Kodeera helps companies create reliable backends, automate manual workflows, optimize slow or costly systems, and modernize legacy software without disrupting daily operations.",
  heroPrimaryCtaText: "Discuss a project",
  heroPrimaryCtaLink: "/contact",
  heroSecondaryCtaText: "See services",
  heroSecondaryCtaLink: "/services",
  heroTrustText: "Free 30-minute consult · No commitment, no charge",
  heroLogoCard: {
    image: "",
    text: "Software systems your business depends on",
  },
  heroCard1: {
    title: "Custom software, not workarounds",
    description: "Built around the real business process, delivered cleanly.",
  },
  heroCard2: {
    title: "Optimization before rebuilding",
    description:
      "Diagnose the slow, fragile part first, then fix what actually creates the pain.",
  },
  heroSectionHide: false,
  buildTag: "How we build",
  buildTitleLead: "How we build",
  buildTitleAccent: "Production Node",
  buildTitleTail: "Services.",
  buildBody:
    "Same engineers from kickoff to handover. Weekly demos. No staff augmentation, no offshore rotation.",
  pillar1: {
    n: "Pillar 01",
    title: "Consultation",
    description:
      "Transparency from the start. We discuss the plan, build a precise deployment roadmap, and at each stage encourage you to participate.",
  },
  pillar2: {
    n: "Pillar 02",
    title: "UI / UX design",
    description:
      "A talented design team creates an accurate user-journey map. User-friendly interfaces built on extensive research Material 3 done right.",
  },
  pillar3: {
    n: "Pillar 03",
    title: "Reliable engineering",
    description:
      "A decade of backend and platform engineering. Node.js services built with the rigour of a typed stack.",
  },
  buildHide: false,
  stat1: { number: "159", label: "Web applications delivered" },
  stat2: { number: "316", label: "Website designs" },
  stat3: { number: "322", label: "Mobile app projects" },
  stat4: { number: "75", label: "Enterprise software solutions" },
  statsHide: false,
  faqTag: "Frequently asked",
  faqTitleLead: "The honest",
  faqTitleAccent: "questions.",
  faqItems: [
    {
      question: "Why choose KODEERA as your London software development company?",
      answer:
        "KODEERA is a London-based software development company that provides mobile, web and AI product development, and helps businesses ship bespoke solutions backed by 15 years of delivery.\nOur senior Product Owners and Project Managers dive into your business goals during Discovery to create a product vision that gives end users a seamless experience.\nTop-notch mobile, web and AI developers plus QA engineers deliver high-quality code at any complexity, and our UI/UX design team ensures the experience meets the strictest guidelines.",
    },
    {
      question: "How long does it take to develop a custom app?",
      answer:
        "Most engagements run 14 to 20 weeks from kickoff to production: one to two weeks of user research, a week of scoping, two to three weeks of design, eight to fourteen weeks of development, two weeks of QA and a week of deployment. A tightly scoped MVP can ship sooner; regulated or integration-heavy platforms take longer. You get the realistic range in writing after the free consult, not after a contract is signed.",
    },
    {
      question: "What tools do you use for mobile & web app development?",
      answer:
        "Swift and SwiftUI on iOS, Kotlin and Jetpack Compose on Android, React Native or Flutter where a shared codebase earns its keep. On the web it is React and Next.js, with Node.js, Python or Laravel behind it and PostgreSQL underneath. Design runs in Figma, delivery runs through Linear, CI/CD through GitHub Actions.",
    },
    {
      question: "What does it cost to hire KODEERA as your software development company?",
      answer:
        "Pricing is fixed against an agreed scope rather than billed against an open-ended hourly estimate. Discovery is a fixed fee, and build work is quoted per phase once the scope is written down. Scope changes are agreed in writing before anyone works on them, so you are never billed for a surprise.",
    },
    {
      question: "Does KODEERA offer AI and machine-learning development?",
      answer:
        "Yes. We integrate hosted models from OpenAI and Anthropic, build retrieval pipelines over vector databases, ship on-device inference with Core ML and TFLite, and design the MCP and agent architecture around them. We are equally willing to tell you when a rules engine would do the job for a tenth of the cost.",
    },
    {
      question: "Where is KODEERA Systems based?",
      answer:
        "Our head office is at 85 Great Portland Street, London, United Kingdom, with a second office at 20 Anang Sugar Lane, Accra, Ghana. We work UK hours by default and are registered under Companies House #03637036.",
    },
    {
      question: "Which industries has KODEERA worked with?",
      answer:
        "Energy and industrial operations, fintech and payments, healthtech, proptech, e-commerce, logistics and enterprise SaaS. The common thread is operational software that people depend on during the working day rather than software that is merely nice to have.",
    },
    {
      question: "Does KODEERA handle GDPR and data-protection compliance?",
      answer:
        "Yes. Our management system is certified to ISO 27001:2022, ISO 9001:2015, ISO 14001:2015 and ISO 45001:2018 by Bureau Veritas. We sign an NDA from day one, keep processing inside the EU or UK where your policy requires it, and hand over a data-flow map and retention policy as part of delivery.",
    },
    {
      question: "Will you support the app after launch?",
      answer:
        "Support is offered as an ongoing technical-ownership retainer: monitoring, dependency and security updates, release oversight and hands-on work when something needs to move. Handover documentation ships with the software either way, so you are never locked in.",
    },
    {
      question: "Who owns the intellectual property?",
      answer:
        "You do. All source code, designs and documentation transfer to you on final payment, along with the repositories, infrastructure definitions and a working local setup. We keep no licence over your product.",
    },
  ],
  faqHide: false,
};

export const emptyDynamicPricing = structuredClone(emptyPricing);
emptyDynamicPricing.heroTitle1 = "Smart Pricing,";
emptyDynamicPricing.heroTitle2 = "Flexible By Design.";

export const emptyContact = {
  nextTag: "What happens next",
  nextTitleLead: "From form to",
  nextTitleAccent: "first call",
  nextTitleTail: "in\n48 hours.",
  nextBody:
    "No marketing nurture sequences, no SDR follow-ups, no AI-written replies. A senior product owner reads it personally.",
  nextStep1: {
    n: "01 / You send the form",
    title: "Five minutes, no nurture sequence.",
    description:
      "A short brief is enough. What the system does, what is going wrong, and roughly when it has to be fixed.",
  },
  nextStep2: {
    n: "02 / We reply within 24h",
    title: "A person, not a sequence.",
    description:
      "A senior product owner reads the brief and replies with the questions that actually narrow the problem.",
  },
  nextStep3: {
    n: "03 / One-page write-up",
    title: "Scope, price, timeline.",
    description:
      "After the call you get a one-page write-up: the realistic shape of the work, what it costs, and how long it takes.",
  },
  nextHide: false,
  formTitleLead: "Tell us about the project.",
  formTitleLead2: "Five minutes no marketing",
  formTitleAccent: "follow-ups.",
  formConsentPre:
    "By sending this I confirm that I have read and accept KODEERA's",
  formConsentLink: "Privacy Policy",
  formConsentHref: "/legal/privacy",
  formHide: false,
  officesTag: "Our offices",
  officesTitleLead: "Two offices,",
  officesTitleAccent: "One standard.",
  officesBody:
    "UK working hours by default. London is our sole office keeping the team close and collaboration simple.",
  office1: {
    country: "Ghana",
    city: "Accra",
    badge: "HQ",
    address: "20 Anang Sugar Lane,",
    phone: "+233 234 759 931",
    email: "info@kodeera.com",
    hours: "MON — FRI  |  09:00 - 18:00 GMT/BST",
    lat: "5.6037",
    lon: "-0.187",
  },
  office2: {
    country: "United Kingdom",
    city: "London",
    badge: "2nd office",
    address: "85 Great Portland Street",
    phone: "+44 20 8040 3369",
    email: "info@kodeera.com",
    hours: "MON — FRI  |  09:00 - 18:00 GMT/BST",
    lat: "51.5205",
    lon: "-0.143",
  },
  officesHide: false,
};

export const emptyProducts = {
  heroBadge: "For litigation work",
  heroTitle: "Reclaim Time\nfor Strategy",
  heroBody:
    "Roostra orchestrates high-stakes document review, deposition analysis, and case chronologies, returning hundreds of hours back to trial strategy.",
  heroVideoCaption: "Explore every angle, sharpen every argument",
  heroPlayLabel: "Play product overview",
  heroPrimaryCtaText: "Request Demo",
  heroPrimaryCtaLink: "/contact",
  heroSecondaryCtaText: "Watch how it works",
  heroSecondaryCtaLink: "#capabilities",
  heroImage: "",
  heroHide: false,
  capBadge: "Core engine capabilities",
  capTitleLead: "Explore every legal vector with",
  capTitleAccent: "precision",
  capBody:
    "Designed by top-tier litigators and machine learning engineers, Roostra automates tedious workflows without sacrificing defense rigor.",
  cap1: {
    icon: "search",
    title: "Intelligent Document Extraction",
    description:
      "Analyze hundreds of medical records, emails, and complaints instantly. Our semantic parsing extracts chronological timestamps and entity maps automatically.",
  },
  cap2: {
    icon: "shield-alert",
    title: "Rigorous Conflict Discovery",
    description:
      "Identify discrepancies and factual contradictions across multi-witness depositions in seconds.",
  },
  cap3: {
    icon: "pen",
    title: "Accelerated Draft Generation",
    description:
      "Generate first-cut memorandums, witness binders, and pleading drafts matching your firm's historical style voice.",
  },
  cap4: {
    icon: "key",
    title: "Sovereign Encryption & Vaulting",
    description:
      "Your data never trains public models. Roostra operates on self-contained, enterprise-grade vault clusters certified with ISO 27001.",
  },
  capHide: false,
  compBadge: "Absolute compliance",
  compTitleLead: "Your knowledge. Protected by",
  compTitleAccent: "Sovereign Vaults",
  compBody:
    "Roostra leverages zero-retention enterprise deployments. Your files are encrypted at rest with AES-256 and processed on dedicated, isolated model endpoints that are never used for general training.",
  compImage: "",
  stat1: { number: "100%", label: "Data Sovereignty" },
  stat2: { number: "SOC2", label: "Type II Compliant" },
  compHide: false,
  workTitleLead: "How litigation teams,",
  workTitleAccent: "use KODEERA.",
  workCtaText: "Learn more",
  workCtaLink: "/contact",
  work1: {
    n: "01",
    title: "Case assessment",
    description:
      "Swiftly evaluate complaints, create chronologies, and identify gaps in factual and legal analysis.",
  },
  work2: {
    n: "02",
    title: "Discovery",
    description:
      "Uncover critical insights, patterns, and key evidence across your entire document collection.",
  },
  work3: {
    n: "03",
    title: "Analysis",
    description:
      "Surface insights faster with AI-driven analysis that identifies patterns, flags anomalies, and delivers actionable recommendations.",
  },
  work4: {
    n: "04",
    title: "Drafting",
    description:
      "Draft, review, and refine contracts, briefs, and legal documents with precision and speed.",
  },
  work5: {
    n: "05",
    title: "Trial preparation",
    description:
      "Organize evidence, draft witness outlines, and build compelling case strategies for trial.",
  },
  work6: {
    n: "06",
    title: "Strategic advice",
    description:
      "Navigate complex legal, regulatory, and tax landscapes with expert guidance tailored to your goals.",
  },
  workHide: false,
  demoBadge: "Built for modern teams",
  demoTitleLead: "Request a",
  demoTitleAccent: "Demo",
  demoBody:
    "See how our platform can help your team work smarter, reduce operational complexity, and scale with confidence.",
  demoCtaText: "Request Demo Access",
  demoCtaLink: "/contact",
  demoHide: false,
};

export const emptyProductsTwo = structuredClone(emptyProducts);
emptyProductsTwo.heroBadge = "For contract teams";
emptyProductsTwo.heroTitle = "Close the Loop\non Every Clause";
emptyProductsTwo.heroBody =
  "The second Roostra module turns contract review into a repeatable pipeline: obligations extracted, renewal dates tracked, and deviations from your playbook flagged before signature.";

export const emptyProductsThree = structuredClone(emptyProducts);
emptyProductsThree.heroBadge = "For compliance teams";
emptyProductsThree.heroTitle = "Evidence, Ready\nBefore the Audit";
emptyProductsThree.heroBody =
  "The third Roostra module keeps regulatory evidence continuously assembled, so control owners answer an audit request from a maintained record rather than a document hunt.";

export const emptyResourcesHero = {
  heroBackground: "",
  heroTag: "About Kodeera — since 2010",
  heroTitle1: "Knowledge Hub",
  heroTitle2: "",
  heroPrimaryCtaText: "Discuss a project",
  heroPrimaryCtaLink: "/contact",
  heroSecondaryCtaText: "See our work",
  heroSecondaryCtaLink: "/resources/cases",
  heroFact1: { label: "Founded", value: "London - 2010" },
  heroFact2: { label: "Team", value: "120+ senior engineers, designers, PMs" },
  heroFact3: { label: "Engagement", value: "Time & materials · fixed scope · embedded" },
  heroFact4: { label: "Languages", value: "English" },
  heroSectionHide: false,
};

export const emptyNewsletterPage = {
  badge: "Newsletter",
  titleLead: "One short email",
  titleAccent: "every month",
  body: "What we shipped, what broke, what we'd do differently. Practical writing from the engineers and product people doing the work. No spam, unsubscribe in one click.",
  perk1: "Monthly, never more",
  perk2: "Written by the engineers",
  perk3: "Unsubscribe in one click",
  latestLabel: "Latest issue",
  readIssue: "Read the issue",
  issueNumber: "Issue {n}",
  pastIssues: "Browse past issues",
  insideEyebrow: "What's inside",
  insideTitleLead: "Four sections,",
  insideTitleAccent: "every issue.",
  insideBody: "The same shape every month, so you can skim straight to the part you care about.",
  insideItem1: {
    title: "What we shipped",
    body: "The releases that went out this month, and the problem each one solved.",
  },
  insideItem2: {
    title: "What broke",
    body: "Incidents and near-misses, written up plainly: no blame, just the cause and the fix.",
  },
  insideItem3: {
    title: "What we'd do differently",
    body: "The lesson we would want in hand if we started the same project tomorrow.",
  },
  insideItem4: {
    title: "Worth reading",
    body: "Articles and customer cases from the Knowledge Hub that pair with the issue.",
  },
  archiveEyebrow: "Archive",
  archiveTitleLead: "Every issue,",
  archiveTitleAccent: "newest first.",
  archiveEmpty: "The first issue is on its way. Subscribe above and it will land in your inbox.",
};

export const emptyCasesHero = {
  heroBackground: "",
  heroTag: "Customer cases",
  heroTitle1: "Systems Our",
  heroTitle2: "Clients Run On",
  heroPrimaryCtaText: "Discuss a project",
  heroPrimaryCtaLink: "/contact",
  heroSecondaryCtaText: "See our work",
  heroSecondaryCtaLink: "#cases",
  heroFact1: { label: "Delivered", value: "159 web applications, 75 enterprise systems" },
  heroFact2: { label: "Industries", value: "Energy · fintech · healthtech · logistics" },
  heroFact3: { label: "Engagement", value: "Time & materials · fixed scope · embedded" },
  heroFact4: { label: "Since", value: "London - 2010" },
  heroSectionHide: false,
};
